import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import RatingsChart from '../ratings-chart/ratings-chart';

import { Maybe } from '../../shared/types/graphql-types';

import styles from './treadwell-bar-row.scss';

export enum TreadwellBarRowColor {
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  GREY_BLUE = 'greyblue'
}

interface TreadwellBarRowInterface {
  barColor?: TreadwellBarRowColor;
  className?: string;
  formattedValue?: string;
  hideFill?: boolean;
  icon?: (props) => React.ReactElement;
  maxRatingLabel?: string;
  midRatingLabel?: string;
  minRatingLabel?: string;
  scale?: number;
  showValueMarker?: boolean;
  showZeroValue?: boolean;
  title?: Maybe<string>;
  tooltip?: Maybe<string>;
  value: number;
}

function TreadwellBarRow(props: TreadwellBarRowInterface) {
  const {
    barColor = TreadwellBarRowColor.GREY,
    className = '',
    formattedValue,
    hideFill,
    icon: Icon,
    maxRatingLabel,
    midRatingLabel,
    minRatingLabel,
    scale,
    showValueMarker = false,
    showZeroValue = false,
    title,
    tooltip,
    value
  } = props;

  return (
    <div className={cn(styles['container'], `treadwell-bar-row ${className}`)}>
      {title && (
        <div className={cn(styles['title'], 'treadwell-bar-row__title')}>
          {Icon && <Icon className={styles['icon']} />}
          <Typography weight="bold">{title}</Typography>
          {tooltip && (
            <Tooltip className={styles['tooltip']} content={tooltip} />
          )}
        </div>
      )}
      <RatingsChart
        className={cn(
          styles['ratings-chart'],
          styles[barColor],
          `treadwell-bar-row__ratings-chart${
            showValueMarker ? '-with-marker' : ''
          }`
        )}
        formattedValue={formattedValue}
        hideFill={hideFill}
        hideLegendNumbers
        hideValueMarker={!showValueMarker}
        scale={scale}
        showZeroValue={showZeroValue}
        value={value}
      />
      <div className={styles['ratings-label-container']}>
        {minRatingLabel && <Typography>{minRatingLabel}</Typography>}
        {midRatingLabel && <Typography>{midRatingLabel}</Typography>}
        {maxRatingLabel && <Typography>{maxRatingLabel}</Typography>}
      </div>
    </div>
  );
}

export default TreadwellBarRow;
